/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { inject as service } from '@ember/service';
import { or } from '@ember/object/computed';
import Component from '@glimmer/component';
import { task } from 'ember-concurrency';
import EventBusService, { VWB_ACTION_UPDATED } from 'cio/services/event-bus';
import ApiService from 'cio/services/api';
import ApiErrorsService from 'cio/services/api-errors';
import ActionSubjectsService from 'cio/services/action-subjects';
import DS from 'ember-data';
import VisualWorkflowBuilderService from 'cio/services/visual-workflow-builder';
import CreateOrUpdatePersonAbstract from 'cio/app-models/action-abstracts/create-or-update-person';

interface CreateOrUpdatePersonEditSidebarArgs {
  actionAbstract: CreateOrUpdatePersonAbstract;
  isAddingOrMoving: boolean;
  onSelect: () => unknown;
  onDeselect: () => unknown;
  onDeleteStarted: () => unknown;
  onDeleteConfirmed: () => unknown;
  hasReadOnlyPermission: boolean;
}

export default class CreateOrUpdatePersonEditSidebar extends Component<CreateOrUpdatePersonEditSidebarArgs> {
  @service api!: ApiService;
  @service apiErrors!: ApiErrorsService;
  @service actionSubjects!: ActionSubjectsService;
  @service eventBus!: EventBusService;
  @service store!: DS.Store;
  @service visualWorkflowBuilder!: VisualWorkflowBuilderService;

  @or('save.isRunning', 'delete.isRunning') isSaving!: boolean;

  save = task({ drop: true }, async () => {
    try {
      let promise = this.args.actionAbstract.saveTask.perform();
      this.visualWorkflowBuilder.redrawConnectingLines();
      await promise;
      this.eventBus.publish(VWB_ACTION_UPDATED, this.args.actionAbstract.action);
      this.args.onDeselect();
    } catch (e) {
      this.apiErrors.report(e);
      throw e;
    }
  });

  delete = task({ drop: true }, async () => {
    try {
      this.args.onDeleteConfirmed();
      await this.args.actionAbstract.deleteTask.perform();
      this.args.onDeselect();
    } catch (e) {
      this.apiErrors.report(e);
      throw e;
    }
  });
}
